import script from "./xt_circular_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_circular_btn.vue?vue&type=script&setup=true&lang=js"

import "./xt_circular_btn.vue?vue&type=style&index=0&id=68ff0a7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ff0a7b"]])

export default __exports__